import { createContext } from 'react';
export const DataTestContext = /*#__PURE__*/createContext(undefined);